import React from 'react'

export const Blogs = () => {
  return (
    <div>blogs</div>
  )
}
